"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
var defaultErrorList = {
    addError: TypescriptHelpers_1.createErrorFunction('Function of default ErrorList context called: addError'),
    removeError: TypescriptHelpers_1.createErrorFunction('Function of default ErrorList context called: removeError'),
    clearErrors: TypescriptHelpers_1.createErrorFunction('Function of default ErrorList context called: clearErrors'),
    errors: [],
};
exports.ErrorListContext = React.createContext(defaultErrorList);
//# sourceMappingURL=ErrorListContext.js.map